import React, { useCallback } from 'react';
import { Icon } from '@vectord/components';
import { DateUtils, TypeUtils } from '@vectord/utils';
import classNames from 'classnames';

import styles from './CoursePauseLearnerDetailsPopover.module.scss';

function CoursePauseLearnerDetailsPopover({ request, handleClose }) {
  const {
    pause_date: pauseDate,
    reason_for_pause: reason,
    source_batch: sourceBatch,
    mentee,
  } = request || {};

  const { email, phone_number: phoneNumber, name } = mentee.user || {};

  const handlePopoverClose = useCallback(() => {
    if (TypeUtils.isFunction(handleClose)) {
      handleClose();
    }
  }, [handleClose]);

  return (
    <div className={classNames(styles.root, 'scroll')}>
      <Icon
        name="clear"
        className={styles.closeIcon}
        onClick={handlePopoverClose}
      />
      <div className={styles.detail}>
        <div className="m-t-xs h5">
          <span className="bold m-r-xxs">Batch:</span>
          {sourceBatch.super_batch.name}
        </div>
        <div className="m-t-xs h5">
          <span className="bold m-r-xxs row wrap">Name:</span>
          {name}
        </div>
        <div className="m-t-xs h5">
          <span className="bold m-r-xxs row wrap">Email:</span>
          {email}
        </div>
        <div className="m-t-xs h5">
          <span className="bold m-r-xxs">Mobile Number:</span>
          {phoneNumber}
        </div>
        <div className="m-t-xs h5">
          <div className="bold m-r-xxs">Reason for Pause</div>
          {reason}
        </div>
        <div className="m-t-xs h5">
          <div className="bold m-r-xxs">Requested On</div>
          {DateUtils.toDDMMMYYYY(pauseDate)}
        </div>
      </div>
    </div>
  );
}

export default CoursePauseLearnerDetailsPopover;
